import React from 'react';
import { Loader2 } from 'lucide-react';

const Loading = ({ fullscreen = false, message = 'Cargando...' }) => {
  if (fullscreen) {
    return (
      <div className="fixed inset-0 bg-gray-900 text-white flex flex-col items-center justify-center z-50">
        <Loader2 className="h-12 w-12 animate-spin mb-4" />
        <p className="text-lg text-gray-300">{message}</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <Loader2 className="h-6 w-6 animate-spin mr-3" />
      <span>{message}</span>
    </div>
  );
};

export default Loading;